import React from 'react';

export const columnsClient = [
  {
    'Header': () => <span className="header-title">USUARIO</span>,
    'accessor': 'dmlUser',
  },
  {
    'Header': () => <span className="header-title">FECHA DML</span>,
    'accessor': 'dmlDate',
  },
  {
    'Header': () => <span className="header-title">TRANSACCIÓN</span>,
    'accessor': 'dmlType',
  },
  {
    'Header': () => <span className="header-title">ID</span>,
    'accessor': 'id',
  },
  {
    'Header': () => <span className="header-title">TIPO DOCUMENTO</span>,
    'accessor': 'documentType',
  },
  {
    'Header': () => <span className="header-title">DOCUMENTO</span>,
    'accessor': 'document',
  },
  {
    'Header': () => <span className="header-title">NOMBRES</span>,
    'accessor': 'names',
  },
  {
    'Header': () => <span className="header-title">APELLIDOS</span>,
    'accessor': 'lastNames',
  },
  {
    'Header': () => <span className="header-title">TIPO CLIENTE</span>,
    'accessor': 'clientType',
  },
  {
    'Header': () => <span className="header-title">CERTIFICACIÓN</span>,
    'accessor': 'certificate',
  },
  {
    'Header': () => <span className="header-title">ID REPRESENTANTE LEGAL</span>,
    'accessor': 'legalRepresentativeId',
  },
  {
    'Header': () => <span className="header-title">NOMBRE REPRESENTANTE LEGAL</span>,
    'accessor': 'legalRepresentativeName',
  },
  {
    'Header': () => <span className="header-title">PORCENTAJE EXONERACIÓN</span>,
    'accessor': 'exonerationPerc',
  },
  {
    'Header': () => <span className="header-title">UBICACIÓN</span>,
    'accessor': 'location',
  },
  {
    'Header': () => <span className="header-title">CIUDAD</span>,
    'accessor': 'city',
  },
  {
    'Header': () => <span className="header-title">PROVINCIA</span>,
    'accessor': 'province',
  },
  {
    'Header': () => <span className="header-title">PAÍS</span>,
    'accessor': 'country',
  },
  {
    'Header': () => <span className="header-title">TELÉFONO</span>,
    'accessor': 'phoneNumber',
  },
  {
    'Header': () => <span className="header-title">EMAIL</span>,
    'accessor': 'email',
  },
  {
    'Header': () => <span className="header-title">RUC DEALER</span>,
    'accessor': 'dealerRuc',
  },
  {
    'Header': () => <span className="header-title">TIPO REPRESENTANTE LEGAL</span>,
    'accessor': 'legalRepresentativeType',
  },
  {
    'Header': () => <span className="header-title">PORCENTAJE DISCAPACIDAD</span>,
    'accessor': 'discapacityPerc',
  },
  {
    'Header': () => <span className="header-title">CÓDIGO CONTRIBUYENTE</span>,
    'accessor': 'contributorCode',
  },
  {
    'Header': () => <span className="header-title">TIENE REPRESENTANTE LEGAL</span>,
    'accessor': 'hasLegalRepresentative',
  },
  {
    'Header': () => <span className="header-title">CREADO POR</span>,
    'accessor': 'createdBy',
  },
  {
    'Header': () => <span className="header-title">FECHA CREACIÓN</span>,
    'accessor': 'createdDate',
  },
  {
    'Header': () => <span className="header-title">ACTUALIZADO POR</span>,
    'accessor': 'updatedBy',
  },
  {
    'Header': () => <span className="header-title">FECHA ACTUALIZACIÓN</span>,
    'accessor': 'updatedDate',
  },
];
